//memberlist strings
export const createdDate = "createdDate";
export const accountType = "accountType";
export const status = "status";
export const title = "title";
export const firstName = "firstName";
export const lastName = "lastName";
export const disName = "disName";
export const country = "country";
export const company = "company";
export const accountCreatedDate = "accountCreatedDate";
export const credentialsSentDate = "credentialsSentDate";
export const guestInviteSentDate = "guestInviteSentDate";
export const sponsorsGroup = "sponsorsGroup";
export const attendeesGroup = "attendeesGroup";
export const organizersGroup = "organizersGroup";
export const speakersGroup = "speakersGroup";
export const userId = "userId";
export const ascendingOrder = "ASC";
export const descendingOrder = "DESC";
export const invalideDate = "1/1/1";
export const yesLabel = "Yes";
export const noLabel = "No";
